import type { Stage } from "./stage.ts";

export function getQualifiedDomainName(
  domainName: string,
  stage: Stage,
): string {
  return stage === "prod" ? domainName : `${stage}.${domainName}`;
}

export function getQualifiedName(name: string, stage: Stage): string {
  return `${stage}-${name}`;
}
